import React from 'react';
import Button from '../Button';

const DirectoryOptOutForm = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="page-container" style={{ maxWidth: 800, margin: '0 auto', background: '#fff', padding: 32, borderRadius: 8 }}>
      <h1>Directory Information Opt-Out Form</h1>
      
      <div style={{ marginBottom: 24 }}>
        <p>Under FERPA, the following may be disclosed as "directory information" unless opted out:</p>
        <ul>
          <li>Student name, grade level, honors/awards, enrollment status</li>
        </ul>
        <p>To opt out of the disclosure of directory information, sign and return this form within 15 calendar days of signing the Participation Agreement.</p>
      </div>

      <div style={{ 
        border: '2px solid #000', 
        padding: 40, 
        marginBottom: 32,
        backgroundColor: '#fff',
        minHeight: '500px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
            DIRECTORY INFORMATION OPT-OUT FORM
          </h2>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Family Educational Rights and Privacy Act (FERPA)
          </p>
        </div>

        <div style={{ marginBottom: 30 }}>
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            Under the Family Educational Rights and Privacy Act (FERPA), educational institutions may disclose "directory information" 
            without prior written consent, unless the parent/guardian opts out of such disclosure.
          </p>
        </div>

        <div style={{ marginBottom: 30 }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '15px' }}>
            Directory Information includes:
          </h3>
          <ul style={{ fontSize: '16px', lineHeight: '1.6', paddingLeft: '20px' }}>
            <li>Student name</li>
            <li>Grade level</li>
            <li>Honors and awards received</li>
            <li>Enrollment status</li>
          </ul>
        </div>

        <div style={{ marginBottom: 40 }}>
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            <strong>I DO NOT consent</strong> to the release of my child's directory information as defined above.
          </p>
        </div>

        <div style={{ marginBottom: 30 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Student Name:
              </label>
              <div style={{ 
                borderBottom: '1px solid #000', 
                height: '30px', 
                marginBottom: '20px' 
              }}></div>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Date:
              </label>
              <div style={{ 
                borderBottom: '1px solid #000', 
                height: '30px', 
                marginBottom: '20px' 
              }}></div>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 30 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flex: 1, marginRight: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Parent/Guardian Signature:
              </label>
              <div style={{ 
                borderBottom: '1px solid #000', 
                height: '30px', 
                marginBottom: '20px' 
              }}></div>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Date:
              </label>
              <div style={{ 
                borderBottom: '1px solid #000', 
                height: '30px', 
                marginBottom: '20px' 
              }}></div>
            </div>
          </div>
        </div>

        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '20px', 
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
            Instructions:
          </h4>
          <ol style={{ fontSize: '14px', lineHeight: '1.5' }}>
            <li>Complete this form with your signature and the current date</li>
            <li>Print this form</li>
            <li>Email the completed form to: <strong>chelsea@edxcelerate.com</strong></li>
            <li>This form must be submitted within 15 calendar days of signing the Participation Agreement</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default DirectoryOptOutForm; 